<template>
    <div class="products-set-list">
        <status-tabs
            :status.sync="status"
            :statusList="statusList"
            :funcName="funcName"
        ></status-tabs>

        <search-tool
            ref="searchTool"
            :status="status"
            :statusList="statusList"
            :funcName="funcName"
            :searchForm="searchForm"
            :searchList="searchList"
            :searchForm_transfer="searchForm_transfer"
            :advanceSearchFields="advanceSearchFields"
            listName="productsSetList"
            :loading="loading"
            :menuAuth="menuAuth"
            :inputPlaceholder="inputPlaceholder"
            :selected="selectList.length"
        ></search-tool>

        <div class="table" :style="{ height: height }">
            <el-table
                :data="tableData"
                ref="tableData"
                height="100%"
                row-key="id"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    align="center"
                ></el-table-column>
                <el-table-column align="center" width="100" label="Image">
                    <template slot-scope="scope">
                        <el-image
                            class="elImage_show"
                            style="height: 80px; width: 80px"
                            fit="fill"
                            :src="
                                scope.row.goods_images &&
                                scope.row.goods_images[0]
                            "
                            :preview-src-list="scope.row.goods_images"
                        >
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                            <div slot="placeholder" class="image-slot">
                                <i class="el-icon-loading"></i>
                            </div>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column
                    property="goods_name"
                    align="left"
                    label="Product Info"
                >
                    <template slot-scope="scope">
                        <div class="tbItem">
                            <div class="goods-name ellipsis-2">
                                {{ scope.row.goods_name }}
                            </div>
                            <div>SPU:&nbsp;{{ scope.row.spu }}</div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    property="status_cn"
                    align="left"
                    label="Status"
                >
                </el-table-column>
                <el-table-column
                    align="left"
                    label="Category"
                    prop="goods_category.name_en"
                    width="150"
                >
                    <template slot-scope="scoped">
                        <div
                            v-for="item of scoped.row.catalog_names"
                            :key="item.name"
                        >
                            {{ item.name_en }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="left" label="Stock" width="200">
                    <template slot-scope="scope">
                        Total Stock :
                        <span class="font-bold">{{
                            scope.row.goods_attribute_sum_stock || 0
                        }}</span>
                        <span class="font-bold" v-if="scope.row.type==2"> , {{
                            scope.row.goods_attribute_count
                        }}</span>
                        <span v-if="scope.row.type==2"> Attribute</span>
                    </template>
                </el-table-column>
                <el-table-column
                    align="left"
                    label="Created On"
                    prop="created_at"
                    width="150"
                ></el-table-column>
                <el-table-column label="Operation" align="left" width="150">
                    <template slot-scope="scope">
                        <operation :scope="scope" @rowDo="rowDo"></operation>
                    </template>
                </el-table-column>
                <el-empty :image-size="120" slot="empty">
                    <img slot="image" src="@/assets/image/empty-data.svg" />
                </el-empty>
            </el-table>
        </div>
        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
            :funcName="funcName"
        ></pagination>
        <add
            :addVisible.sync="addVisible"
            :funcName="funcName"
            :treeData="treeData"
            :goodsTagList="goodsTagList"
        ></add>
        <edit
            :editVisible.sync="editVisible"
            :tableItem.sync="tableItem"
            :funcName="funcName"
            :treeData="treeData"
            :goodsTagList="goodsTagList"
        ></edit>
        <detail
            :detailVisible.sync="detailVisible"
            :tableItem.sync="tableItem"
            :treeData="treeData"
            :goodsTagList="goodsTagList"
        ></detail>
        <setPrivate
            :setPrivateVisible.sync="setPrivateVisible"
            :tableItem.sync="tableItem"
        ></setPrivate>
        <setTime
            :setProcessingTimeVisible.sync="setProcessingTimeVisible"
            :tableItem.sync="tableItem"
        ></setTime>
        <setCombine
            :setCombineSkuVisible.sync="setCombineSkuVisible"
            :tableItem.sync="tableItem"
        ></setCombine>
        <importPublic
            :importVisible.sync="importVisible"
            :parentFuncName="funcName"
            :methodName="'productsImport'"
            :temSrc="'sale/goods/importTemple'"
            :title="$i18n.locale == 'zh' ? '产品导入' : 'Import Product'"
        ></importPublic>
        <skuTemp :skuTempVisible.sync="skuTempVisible"></skuTemp>
        <generate
            :generateVisible.sync="generateVisible"
        ></generate>
    </div>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { infoTagsMixins } from "@/utils/infoTagsMixins.js";
import { tableMixins } from "@/utils/tableMixins.js";
import importPublic from "@/common/components/importPublic";
import add from "./productsSetList/add.vue";
import edit from "./productsSetList/edit.vue";
import detail from "./productsSetList/detail.vue";
import setPrivate from "./productsSetList/setPrivate.vue";
import setTime from "./productsSetList/setTime.vue";
import setCombine from "./productsSetList/setCombine.vue";
import skuTemp from "./productsSetList/skuTemp.vue";
import generate from "@/common/components/generateDialog.vue";
export default {
    // 有些表格的相同部分 , 抽离在了tableMixins混合器里面
    mixins: [infoTagsMixins, tableMixins],
    data() {
        return {
            inputPlaceholder: "Keywords include Product Name、SPU、SKU",
            searchForm: {
                status:"",
                catalog_id: "",
                processing_time: "",
                is_combine_sku: "",
                goods_type: "",
            },
            searchForm_transfer: {},
            funcName: "productsSetList",
            addVisible: false,
            editVisible: false,
            detailVisible: false,
            setPrivateVisible: false,
            setProcessingTimeVisible: false,
            setCombineSkuVisible: false,
            selectList: [],
            goodsTypeList:[
                {
                    label: "Single",
                    value: "1",
                },
                {
                    label: "Multi Attribute",
                    value: "2",
                },
            ],
            searchList: [
                {
                    label: "Category",
                    key: "catalog_id",
                    type: "dataCascader",
                    props: {
                        list: [],
                        nameKey: "name_en",
                        valueKey: "id",
                        childrenKey: "cat_id"
                    },
                },
                {
                    label: "Processing Time",
                    key: "processing_time",
                    type: "select",
                    props: {
                        list: [],
                        nameKey: "label",
                        valueKey: "value",
                    },
                },
                {
                    label: "Combination  SKU",
                    key: "is_combine_sku",
                    type: "select",
                    props: {
                        list: [],
                        nameKey: "label",
                        valueKey: "value",
                    },
                },
                {
                    label: "Product Type",
                    key: "goods_type",
                    type: "select",
                    props: {
                        list: [],
                        nameKey: "label",
                        valueKey: "value",
                    },
                }
            ],
            advanceSearchFields: {
                status: {
                    label: "Status",
                    type: "select",
                    options: [],
                },
                catalog_id: {
                    label: "Category",
                    type: "dataCascader",
                    options: [],
                    cascaderProps: {
                        value: "id",
                        label: "name_en",
                        children: "cat_id",
                        checkStrictly: false,
                        multiple: true,
                    },
                },
                processing_time: {
                    label: "Processing Time",
                    type: "select",
                    options: [],
                    props: {
                        value: "value",
                        label: "label",
                        checkStrictly: false,
                        multiple: true,
                    },
                },
                is_combine_sku: {
                    label: "Combination SKU",
                    type: "select",
                    options: [],
                },
                goods_type: {
                    label: "Product Type",
                    type: "select",
                    options: [],

                },
            },
            importVisible: false,
            skuTempVisible: false,
            treeData: [],
            goodsTagList: [],
            generateVisible: false,
            processingList:[
                {
                    label: "1-3 days",
                    value: 1,
                },
                {
                    label: "3-5 days",
                    value: 2,
                },
                {
                    label: "5-7 days",
                    value: 3,
                },
                {
                    label: "More than 7 days",
                    value: 4,
                },
            ],
            combineList:[
                {
                    label: "Yes",
                    value: "1",
                },
                {
                    label: "No",
                    value: "2",
                },
            ],

        };
    },
    methods: {
        add() {
            this.addVisible = true;
        },
        skuTemp() {
            this.skuTempVisible = true;
        },
        setPrivate() {
            this.setPrivateVisible = true;
        },
        setProcessTime() {
            this.setProcessingTimeVisible = true;
        },
        setCombineSku() {
            this.setCombineSkuVisible = true;
        },
        export(){
            cmofferApi
            .productsSetExport(
                {
                    ...this.paginationData,
                    ...this.searchForm,
                    ids: this.selectList,
                    menu_id: this.menu_id,
                    status: this.status,
                },
                "get"
            )
            .then((res) => {
                this.loading = false;
                if (res.errcode == 0) {
                    this.generateVisible = true;
                }
            });
        },
        del(item) {
            cmofferApi
                .productsSetList({}, "delete", item.rowId)
                .then((res) => {
                    if (res) {
                        this.$message.success(
                            `${item.name} ${
                                this.$i18n.locale == "zh" ? "成功" : "Success"
                            }`
                        );
                        this.productsSetList();
                    }
                })
                .catch(() => {});
        },
        // 获取产品集列表
        productsSetList(page) {
            this.loading = true;
            page ? (this.paginationData.page = 1) : "";
            let mergeObj = {}
            if (this.searchForm.catalog_id) {
                const catalogId = []
                this.searchForm.catalog_id.forEach(item => {
                    catalogId.push(item[item.length - 1])
                })
                mergeObj = {catalog_id: catalogId.join(',')}
            }
            cmofferApi
                .productsSetList(
                    {
                        ...this.paginationData,
                        ...this.searchForm,
                        ...mergeObj,
                        menu_id: this.menu_id,
                        status: this.status,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.closeDrawer();
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.statusList = res.ext.tabs;
                        this.menuAuth = res.ext.op_auth;
                        this.advanceSearchFields.status.options =
                            res.ext.tabs.map((item) => {
                                return { label: item.name, value: item.status };
                            });
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        /**
         * table内权限按钮
         */
        rowDo(item, row) {
            
            if (item.status_flag == 1) {
                this.tableItem = row;
                if (item.funcName == "add") {
                } else if (item.funcName == "edit") {
                    this.editVisible = true;
                } else if (item.funcName == "detail") {
                    this.detailVisible = true;
                }
            } else if (item.status_flag == 2) {
                this.$prompt(`Do you want to continue?`, "Tip", {
                    inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                    inputErrorMessage: `Please enter ${item.name}Reason`,
                    inputPlaceholder: `${item.name}Reason`,
                })
                    .then(({ value }) => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                                reason: value,
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 3) {
                this.$confirm(`Do you want to continue?`, "Tip", {
                    type: "warning",
                })
                    .then(() => {
                        cmofferApi[item.funcName](
                            {
                                id_list: [row.id],
                            },
                            "put"
                        ).then((res) => {
                            if (res) {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} Success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message.info("Cancelled");
                    });
            } else if (item.status_flag == 4) {
                if (item.funcName == "delete") {
                    cmofferApi[item.parent_funcname](
                        {},
                        "delete",
                        item.rowId
                    ).then((res) => {
                        if (res) {
                            this.$message.success(`${item.name} Success`);
                            this[item.parent_funcname]();
                        }
                    });
                }
            }
        },
        batchChangeStatus(item) {
            if (this.selectList.length) {
                if (item.status_flag == 2) {
                    this.$prompt(`Do you want to continue?`, "Tip", {
                        // inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
                        inputErrorMessage: `Input ${item.name} reason`,
                        inputPlaceholder: `${item.name} reason`,
                    })
                        .then(({ value }) => {
                            cmofferApi[item.funcName](
                                {
                                    ids: this.selectList,
                                    remark: value,
                                },
                                "post"
                            ).then((res) => {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            });
                        })
                        .catch(() => {
                            // this.$message.info("已取消操作");
                        });
                } else if (item.status_flag == 3) {
                    this.$confirm(`Do you want to continue?`, "Tip", {
                        type: "warning",
                    })
                        .then(() => {
                            cmofferApi[item.funcName](
                                {
                                    ids: this.selectList,
                                    status:
                                        item.name_en == "Onsale"
                                            ? 1
                                            : item.name_en == "Eliminate"
                                            ? 60
                                            : "",
                                },
                                "post"
                            ).then((res) => {
                                if (res) {
                                    this.$message.success(
                                        `${item.name} success`
                                    );
                                    this[item.parent_funcname]();
                                }
                            });
                        })
                        .catch(() => {
                            // this.$message.info("已取消操作");
                        });
                }
            } else {
                this.$message.warning("Please select item");
            }
        },
        /**
         清空高级搜索
        */
        clean() {
            this.searchForm = {};
            this.searchForm_transfer = {};
        },
        import() {
            this.importVisible = true;
        },
        /**
         * 获取 sku组件回传的tags
         */
        getSkuTags(value) {
            this.searchForm.sku_list = value;
        },

        handleSelectionChange(val) {
            this.selectList = [];
            for (let i in val) {
                this.selectList.push(val[i].id);
            }
        },
        searchTags(params) {
            this.searchForm[params.key] = params.value;
        },
        closeTagsItem(key) {
            this.searchForm[key] = "";
        },
        closeTagsAll() {
            this.clean();
        },
        async initialize() {
            await this.productsSetList();
            this.goodsCategory();
            this.goodsTagsSelect();
            this.advanceSearchFields.processing_time.options = this.processingList.map((item) => {
                                return { label: item.label, value: item.value };
                            });
            this.advanceSearchFields.is_combine_sku.options = this.combineList.map((item) => {
                                return { label: item.label, value: item.value };
                            });
            this.advanceSearchFields.goods_type.options = this.goodsTypeList.map((item) => {
                                return { label: item.label, value: item.value };
                            });
            for (let k in this.searchList){
                if(this.searchList[k].key == 'processing_time'){
                    this.searchList[k].props.list = this.processingList
                }
                if(this.searchList[k].key == 'is_combine_sku'){
                    this.searchList[k].props.list = this.combineList
                }
                if(this.searchList[k].key == 'goods_type'){
                    this.searchList[k].props.list = this.goodsTypeList
                }
            }
        },
        // 跳转到商品详情
        toGoodsDetail(item) {
            this.$router.push({
                path: `/goodsList/detail`,
                query: {
                    id: item.goods_id,
                },
            });
        },
        // 分类树
        goodsCategory() {
            cmofferApi.goodsCategory({}, "get").then((res) => {
                if (res) {
                    this.treeData = res.data;
                    this.advanceSearchFields.catalog_id.options = res.data;
                    this.searchList.find(item => item.key === 'catalog_id').options = res.data;
                }
            });
        },
        // 分类标签
        goodsTagsSelect() {
            cmofferApi.goodsTagsSelect({}, "get").then((res) => {
                if (res) {
                    this.goodsTagList = res.data;
                }
            });
        },
    },
    activated() {
        this.initialize();
    },
    components: {
        add,
        edit,
        detail,
        importPublic,
        skuTemp,
        setPrivate,
        setTime,
        setCombine,
        generate,
    },
    computed: {},
    watch: {
        searchForm: {
            handler(newValue) {
                for (let k in newValue) {
                    let v = newValue[k];
                    if (!!v) {
                        this.hasSearchCondition = true;
                        return;
                    }
                }

                this.hasSearchCondition = false;
            },
            deep: true,
            immediate: true,
        },
    },
};
</script>
<style lang="scss">
.products-set-list {
    width: 100%;
    height: 100%;
    background: #fff;
    .table {
        margin: 0 15px !important;
        padding: 0 !important;
        width: auto !important;

        height: calc(100% - 120px);
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }

        &.has-search-condition {
            height: calc(100% - 192px);
        }
    }
    .goods-name {
        color: $color-333333;
        font-weight: bold;
    }
    .font-bold {
        font-weight: bold;
    }
}
</style>
